import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./_start/assets/sass/style.scss";
import TestApp from "./app/TestApp";

const { PUBLIC_URL } = process.env;

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container!);
  root.render(<App basename={PUBLIC_URL ?? ""} />);
}

const testContainer = document.getElementById("testRoot");
if (testContainer) {
  const testRoot = createRoot(testContainer!);
  testRoot.render(<TestApp />);
}
